import {minZero} from '@shared/helpers/lang'
import {createStateMaker} from '@shared/helpers/object'

import {APIStatus, NaverPointStatus} from '@web/core/constants'

import {PointPaymentState} from './interfaces'

export const getInitialState = (): PointPaymentState => ({
    naverPayPoint: {
        amount: 0,
        usePointAll: false,
        usingAmount: 0,
        preferredPoint: {
            sequences: [],
            apiStatus: APIStatus.IDLE,
        },
        status: NaverPointStatus.ENABLE,
    },
    exposeAmlGuideMessage: false,
})

export const makeMock = createStateMaker<PointPaymentState>(getInitialState)

export const makeNaverPayPointMock = createStateMaker<PointPaymentState['naverPayPoint']>(
    () => getInitialState().naverPayPoint,
)

export const getNaverPayPointAmount = ({
    rewardPoint,
    chargePoint,
    isPayMoneyUser,
}: {
    rewardPoint: number
    chargePoint: number
    isPayMoneyUser: boolean
}) => {
    const rewardPointAmount = minZero(rewardPoint)
    const chargePointAmount = minZero(chargePoint)

    return isPayMoneyUser ? rewardPointAmount : rewardPointAmount + chargePointAmount
}
